/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/disputes/dispute
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDisputeEvidenceKey,
  ShopifyDisputeEvidenceToDisputeKey,
  ShopifyDisputeKey,
  ShopifyDisputeToEvidenceKey,
  ShopifyDisputeToOrderKey,
  ShopifyDisputeToShopKey,
  ShopifyOrderKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

// we added shopify field keys in 2025-04 which changes how the static keys are generated. these are here so that they remain the same
const initiatedAtKey = "ModelField-DataModel-Shopify-Dispute-initiatedAt";
const initiatedAtStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Dispute-initiatedAt-initial";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDisputeKey,
  "2022-01": {
    name: "Shopify Dispute",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "type" } },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "currency" } },
      },
      {
        name: "Amount",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "amount" } },
      },
      {
        name: "Reason",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "reason" } },
      },
      {
        name: "Network Reason Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "network_reason_code" } },
      },
      {
        name: "Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status" } },
      },
      {
        name: "Evidence Due By",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "evidence_due_by" } },
      },
      {
        name: "Evidence Sent On",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "evidence_sent_on" } },
      },
      {
        name: "Finalized On",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "finalized_on" } },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDisputeToOrderKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_id" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDisputeToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "dispute" },
  },
  "2022-07": {
    fields: [
      {
        name: "Dispute Evidence",
        key: ShopifyDisputeToEvidenceKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "dispute_evidence" } },
        configuration: {
          relatedModelKey: ShopifyDisputeEvidenceKey,
          inverseFieldKey: ShopifyDisputeEvidenceToDisputeKey,
          dependent: "delete",
        },
      },
    ],
  },
  "2025-04": {
    graphQLTypename: "ShopifyPaymentsDispute",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Type",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "type",
            graphQLFieldKey: "type",
            isShopifyEnum: true,
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "CHARGEBACK" }, { name: "INQUIRY" }],
        },
      },
      {
        name: "Currency",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "currency",
            graphQLFieldKey: "currency",
            skipGraphQLSelection: true,
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Amount",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "amount",
            graphQLFieldKey: "moneyAmount",
            skipGraphQLSelection: true,
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Reason",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "reason",
            graphQLFieldKey: "reason",
            skipGraphQLSelection: true,
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Network Reason Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "network_reason_code",
            graphQLFieldKey: "networkReasonCode",
            skipGraphQLSelection: true,
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            isShopifyEnum: true,
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ACCEPTED" },
            { name: "LOST" },
            { name: "NEEDS_RESPONSE" },
            { name: "UNDER_REVIEW" },
            { name: "WON" },
            { name: "CHARGE_REFUNDED" },
          ],
        },
      },
      {
        name: "Evidence Due By",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "evidence_due_by",
            graphQLFieldKey: "evidenceDueBy",
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Evidence Sent On",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "evidence_sent_on",
            graphQLFieldKey: "evidenceSentOn",
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Finalized On",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "finalized_on",
            graphQLFieldKey: "finalizedOn",
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDisputeToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "order_id",
            graphQLFieldKey: "order",
            graphQLSelection: "id",
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Dispute Evidence",
        key: ShopifyDisputeToEvidenceKey,
        fieldType: FieldType.HasOne,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "dispute_evidence" } },
        configuration: {
          relatedModelKey: ShopifyDisputeEvidenceKey,
          inverseFieldKey: ShopifyDisputeEvidenceToDisputeKey,
          dependent: "delete",
        },
      },
      {
        name: "Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "amount",
            // intentionally empty because there is an `Amount` field with `shopifyFieldKey: "amount"` as well
            availableInWebhook: [],
            graphQLSelection: `
          amount
          currencyCode
          `,
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Reason Details",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "reasonDetails",
            graphQLSelection: `
          networkReasonCode
          reason
          `,
            graphQLOnlyField: true,
          },
        },
      },
      {
        name: "Initiated At",
        key: initiatedAtKey,
        initialStorageEpochKey: initiatedAtStorageEpochKey,
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "initiatedAt",
            shopifyFieldKey: "initiated_at",
            availableInWebhook: ["disputes/create", "disputes/update"],
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "disputes",
      filters: {},
    },
  },
};

export const ShopifyDispute = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
